module.exports = __webpack_public_path__ + "img/selected4-min.bb764191.png";